/**
 * The states of the password reset process
 * @enum
 */
export enum PasswordResetState {
  /**
   * Initial state, reset process has not started
   */
  NOT_STARTED,
  /**
   * Failed to send the reset code
   */
  CODE_SEND_FAILED,
  /**
   * A code has been sent to the user (if lambda is setup they receive an email with embedded code link)
   */
  CODE_SENT,
  /**
   * Have they reached the route with a code and user embedded in the link
   */
  CODE_EMBEDDED,
  /**
   * The code is invalid
   */
  CODE_INVALID,
  /**
   * The reset process is complete
   */
  COMPLETE, // the reset process is complete
}